const RATE_USD_TO_GEL = 2.68;

export function toGel(value, currency) {
  const num = Number(value);
  if (!Number.isFinite(num)) return NaN;

  return currency === "USD"
    ? Math.round(num * RATE_USD_TO_GEL)
    : Math.round(num);
}

export function fromGel(value, currency) {
  const num = Number(value);
  if (!Number.isFinite(num)) return NaN;

  return currency === "USD"
    ? Math.round(num / RATE_USD_TO_GEL)
    : Math.round(num);
}


